import { Modal } from "antd";
import React from "react";
import styles from "./ShowImage.module.scss";
interface ImagesProps {
  showImageModal: boolean;
  setShowImagesModal: (value: boolean) => void;
  image: string;
}
const ShowImage: React.FC<ImagesProps> = ({
  showImageModal,
  setShowImagesModal,
  image,
}) => {
  return (
    <Modal
      open={showImageModal}
      onCancel={() => setShowImagesModal(false)}
      footer={null}
      style={{ minWidth: "340px" }}
      centered
    >
      <div className={styles.image}>
        <div className={styles.img}>
          <img src={image} alt="product" />
        </div>
      </div>
    </Modal>
  );
};

export default ShowImage;
